module.exports = __webpack_public_path__ + "img/modelo_small5.3cdd82ac.png";